import React from "react";

export default function Internes() {
	return (
		<>
			<div className="beratung_cont" id="control_system">
				<h1>Internes Kontrollsystem</h1>
				<h2>Unsere Philosophie: So wenig wie möglich, so viel wie nötig</h2>
				<p>
					...denn Wertschöpfung im engeren Sinne entsteht an anderer Stelle.
				</p>
				<p>
					Die Notwendigkeit für die Implementierung und Aufrechterhaltung eines
					Internen Kontrollsystems (IKS) fußt auf einer Vielzahl rechtlichen
					Anforderungen wie z.B. dem Aktiengesetz oder dem HGB. Es besteht aus
					systematisch gestalteten, technischen und organisatorischen
					Regelungen, Maßnahmen und Abläufen zur Überwachung und Steuerung
					wesentlicher Prozesskontrollen und dient der Einhaltung von
					Richtlinien und der Abwehr von Schäden, die durch das eigene Personal
					oder Dritte verursacht werden können.
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>
						Umfassende Erfahrung im Design von Kontrollumfeldern, Ableitung von
						IKS-Zielen und Kontrollen sowie deren Testung, dem IKS-Berichtswesen
						und der Überwachung sowie kontinuierlichen Verbesserung
					</li>
					<li>
						In Anlehnung an unseren Philosophie ist unser Handeln stets an
						pragmatischen und effizienten Lösungen angelehnt; dennoch angemessen
						und entsprechen der regulatorischen Vorgaben.
					</li>
					<li>
						Berücksichtigung neuer Entwicklungen wie Risiken aus dem Bereich
						Nachhaltigkeit, Lieferketten etc.
					</li>
					<li>
						Als Partner übernehmen wir aus Funktionen wie z.B. den
						IKS-Koordinator und entlasten Sie bezüglich Ihrer eigenen
						personeller Kapazitäten, Stellvertretungen etc.
					</li>
				</ul>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
